import { useAccount, useDisconnect } from "wagmi";
import DisconnectButton from "./wallet/DisconnectButton.tsx";
import WalletStatus from "./wallet/WalletStatus.tsx";
import { useNavigate } from "react-router";
import {LogsIcon, WrenchIcon} from "lucide-react";
import {useStaffGuard} from "../hooks/useStaffGuard.ts";

const Navbar = () => {
  const { address, chain } = useAccount();
  const { disconnect } = useDisconnect();
  const navigate = useNavigate();
  const { isStaff, isLoading } = useStaffGuard();

  const handleDisconnect = () => {
    disconnect();
  };


  return (
    <nav className="bg-base-300 p-4 w-64 flex flex-col h-screen">
        <div className="container mx-auto flex flex-col h-full">
            <span className="text-lg font-bold">Escrow</span>
            <WalletStatus address={address!} chain={chain} />
            <div className="divider" />

        <ul className="menu bg-base-200 rounded-box w-56 gap-1">
          <li onClick={() => navigate("/")}>
            <a>
              <LogsIcon />
              <a>Escrow en cours</a>
            </a>
          </li>
          {isStaff ? (
            <li
              className={`${isLoading ? "opacity-50 animate-pulse" : "opacity-100"}`}
              onClick={() => navigate("/factory")}
            >
              <a>
                <WrenchIcon />
                <a>Escrow Factory</a>
              </a>
            </li>
          ) : undefined}
        </ul>
      </div>
        <DisconnectButton onClick={handleDisconnect} />
    </nav>
  );
};

export default Navbar;
